import React, { useState } from "react";
import styles from "./AddProductModal.module.css";

const AddChildModal = ({
  onClose,
  parentId,
  refetchAllProducts,
  parentData,
}) => {
  // console.log("parentAppName", parentAppName);

  const [form, setForm] = useState({
    app_name: "",
    img_url: parentData.img_url,
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const productData = {
      app_name: form.app_name,
      img_url: form.img_url,
      description: form.description,
      parent_id: parentId,
      pricing: {
        india: [],
        global: [],
      },
      app_details: [],
      sub_category_id: parentData.sub_category_id,
      children_ids: [],
      similar_apps: parentData.similar_apps || [],
      features: parentData.features || [],
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/add-product`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(productData),
        }
      );

      if (res.status === 200) {
        alert("Child product added successfully");
        onClose();
        refetchAllProducts();
      } else {
        const err = await res.json();
        alert("Error: " + (err.message || err.msg || "Failed to add product"));
      }
    } catch (error) {
      console.error("Fetch error:", error);
      alert("Network error while adding product.");
    }
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <h2>Add Child Product</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="app_name"
            placeholder="Child App Name"
            value={form.app_name}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="Enter child description"
            value={form.description}
            onChange={handleChange}
            rows={4}
            required
          />

          <div className={styles.buttonRow}>
            <button type="submit">Submit</button>
            <button type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddChildModal;
